import { forwardRef, memo } from "react";

export const CoinIcon = memo(
  forwardRef(function CoinIcon(
    { size = 26, color = "currentColor", title, className, ...rest },
    ref,
  ) {
    return (
      <svg
        ref={ref}
        width={size}
        height={size}
        viewBox="0 0 23 23"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden={title ? undefined : true}
        focusable="false"
        className={className}
        {...rest}
      >
        {title ? <title>{title}</title> : null}
        <path
          d="M10.2276 12.7772H8.8121C7.72689 12.7772 6.84928 11.8713 6.84928 10.7484C6.84928 10.3615 7.17013 10.0406 7.55703 10.0406C7.94393 10.0406 8.26477 10.3615 8.26477 10.7484C8.26477 11.0881 8.51013 11.3617 8.8121 11.3617H10.2276C10.4446 11.3617 10.6145 11.1636 10.6145 10.9182C10.6145 10.5879 10.5579 10.5691 10.3408 10.4936L8.0666 9.7009C7.24562 9.4178 6.83984 8.84216 6.83984 7.94568C6.83984 6.92653 7.65139 6.08667 8.64224 6.08667H10.0577C11.1429 6.08667 12.0205 6.99259 12.0205 8.11554C12.0205 8.50245 11.6997 8.82329 11.3128 8.82329C10.9259 8.82329 10.6051 8.50245 10.6051 8.11554C10.6051 7.77583 10.3597 7.50216 10.0577 7.50216H8.64224C8.4252 7.50216 8.25534 7.70033 8.25534 7.94568C8.25534 8.27597 8.31196 8.29484 8.529 8.37033L10.8032 9.16301C11.6242 9.45554 12.0205 10.0312 12.0205 10.9182C12.03 11.9468 11.2184 12.7772 10.2276 12.7772Z"
          fill={color}
        />
        <path
          d="M9.43822 13.5321C9.05131 13.5321 8.73047 13.2113 8.73047 12.8244V12.1261C8.73047 11.7392 9.05131 11.4183 9.43822 11.4183C9.82512 11.4183 10.146 11.7392 10.146 12.1261V12.8244C10.146 13.2207 9.82512 13.5321 9.43822 13.5321Z"
          fill={color}
        />
        <path
          d="M9.43822 7.49274C9.05131 7.49274 8.73047 7.17189 8.73047 6.78499V6.04893C8.73047 5.66203 9.05131 5.34119 9.43822 5.34119C9.82512 5.34119 10.146 5.66203 10.146 6.04893V6.78499C10.146 7.17189 9.82512 7.49274 9.43822 7.49274Z"
          fill={color}
        />
        <path
          d="M9.42729 17.6654C4.87884 17.6654 1.17969 13.9662 1.17969 9.41777C1.17969 4.86932 4.87884 1.17017 9.42729 1.17017C13.9757 1.17017 17.6749 4.86932 17.6749 9.41777C17.6749 13.9662 13.9663 17.6654 9.42729 17.6654ZM9.42729 2.5951C5.66208 2.5951 2.59518 5.662 2.59518 9.42721C2.59518 13.1924 5.66208 16.2499 9.42729 16.2499C13.1925 16.2499 16.2594 13.183 16.2594 9.41777C16.2594 5.65256 13.1925 2.5951 9.42729 2.5951Z"
          fill={color}
        />
        <path
          d="M16.0593 21.44C14.3135 21.44 12.6715 20.5907 11.6618 19.1563C11.4353 18.8355 11.5108 18.392 11.8317 18.1655C12.1525 17.939 12.596 18.0145 12.8225 18.3353C13.568 19.3922 14.7759 20.0151 16.0593 20.0151C18.2486 20.0151 20.0226 18.241 20.0226 16.0517C20.0226 14.7777 19.3998 13.5698 18.3618 12.8244C18.041 12.5979 17.9749 12.1544 18.2014 11.8335C18.4279 11.5127 18.8714 11.4466 19.1922 11.6731C20.5983 12.6828 21.4381 14.3153 21.4381 16.0517C21.4381 19.0337 19.0318 21.44 16.0593 21.44Z"
          fill={color}
        />
      </svg>
    );
  }),
);

CoinIcon.displayName = "CoinIcon";